import { createFileRoute } from '@tanstack/react-router';
import { AuthenticatedLayout } from '@/features/nav/AuthenticatedLayout';

export const Route = createFileRoute('/_authenticated')({ component: AuthenticatedLayout });
